'use strict';

class Track {
    constructor(e) {
        this._e = document.getElementById(e);
    }

    /**
     * биндит на форму события
     */
    bind() {
        this.requestTrack($(this._e));
    }

    /**
     * Запрос на получения трека
     * @param form
     */
    requestTrack(form){
        $(form).on('beforeSubmit', () => {
            let e = '#track-result';
            let form_group = $(form).find('.form-group');
            let url = '/ajax/track';
            let data = $(form).serializeArray();

            form_group.toggleClass('has-warning');

            $(e).empty();

            let callback = () => {
                $('#track').modal('show');
                form_group.toggleClass('has-warning');
                //todo: need ref
                $('#callbacktrack-track').val($('#meatrackform-track').val());
            };

            let request = new AjaxParts(e, {
                url: url,
                data: data,
                callback: callback
            })

            request.ajaxRequest();

            return false;
        })
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = Track;
}